"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCheckout = exports.CheckoutProvider = void 0;
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
// This can be extended by specific types for your Online properties
const checkoutContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const CheckoutProvider = (param)=>{
    let { configuration, children } = param;
    const { shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    const value = (0, _react.useMemo)(()=>{
        var _shoppingContext_showQuickOrderUnit, _shoppingContext_shoppingBag_maxProductQuantity, _shoppingContext_periodId, _shoppingContext_customerId;
        return {
            ...configuration,
            isQofVisible: (_shoppingContext_showQuickOrderUnit = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.showQuickOrderUnit) !== null && _shoppingContext_showQuickOrderUnit !== void 0 ? _shoppingContext_showQuickOrderUnit : configuration.isQofVisible,
            maxValue: (_shoppingContext_shoppingBag_maxProductQuantity = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.shoppingBag.maxProductQuantity) !== null && _shoppingContext_shoppingBag_maxProductQuantity !== void 0 ? _shoppingContext_shoppingBag_maxProductQuantity : configuration.maxValue,
            periodId: (_shoppingContext_periodId = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.periodId) !== null && _shoppingContext_periodId !== void 0 ? _shoppingContext_periodId : configuration.periodId,
            customerId: (_shoppingContext_customerId = shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.customerId) !== null && _shoppingContext_customerId !== void 0 ? _shoppingContext_customerId : configuration.customerId
        };
    }, [
        configuration,
        shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.customerId,
        shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.periodId,
        shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.shoppingBag.maxProductQuantity,
        shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.showQuickOrderUnit
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(checkoutContext.Provider, {
        value: value,
        children: children
    });
};
exports.CheckoutProvider = CheckoutProvider;
const useCheckout = ()=>{
    const ctx = (0, _react.useContext)(checkoutContext);
    if (!ctx) {
        throw new Error('useCheckout must be used within a CheckoutProvider');
    }
    return ctx;
};
exports.useCheckout = useCheckout;
